import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";

function UpdatePostContent() {
  const editor = useRef(null);
  const navigate = useNavigate();
  const { srno } = useParams();
  const [formData, setFormData] = useState({
    postcontentid: "",
    postcontentname: "",
    postcontenttitle: "",
    postcontent: "",
    postcontenttype: "",
    postid: "",
    postlocationid: "",
    isactive: 1
  });

  const [allPosts, setAllPosts] = useState([]);
  const callApiPostContent = async () => {
    try {
      const headers = {
      'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + "postcontent/showAll";
      const response = await axios.get(url, {headers});
      setAllPosts(response.data);
    } catch (error) {
      toast.error("Couldn't Fetch Post Content Data", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    if (allPosts.length === 0) {
      callApiPostContent();
    }
    const matchingPost = allPosts.find(
      (item) => item.srno === parseInt(srno, 10)
    );
    if (matchingPost) {
      setFormData(matchingPost);
    }
  }, [srno, allPosts]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleContentChange = (newContent) => {
    setFormData({ ...formData, postcontent: newContent });
  };

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const callApiUpdateContent = async () => {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + "postcontent/updates/" + srno;
      return axios.put(url, formData, { headers });
    };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setShowUpdateModal(false);
    if (
      !formData.postcontentid ||
      !formData.postcontentname ||
      !formData.postcontenttitle ||
      !formData.postcontent ||
      !formData.postcontenttype ||
      !formData.postid ||
      !formData.postlocationid
    ) {
      toast.error("Missing required parameters.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    } 
      try {
        await callApiUpdateContent();
        toast.success("Post Content Updated Successfully", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      
      setTimeout(() => {
        navigate("/postlist");
      }, 2000);
      
      } catch (error) {
      console.error("Update error:", error);
      toast.error("Post Content not updated", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowUpdateModal(true);
  };

  return (
    <>
       <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Update Post Content
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="srno">
                  <Form.Label>Sr No:</Form.Label>
                  <Form.Control
                    type="number"
                    name="srno"
                    value={formData.srno}
                    readOnly
                    placeholder="srno"
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="postcontentid">
                  <Form.Label>Post Content Id:</Form.Label>
                  <Form.Control
                    type="text"
                    name="postcontentid"
                    value={formData.postcontentid}
                    onChange={handleChange}
                    placeholder="Post Content Id"
                    maxLength={50}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="postcontentname">
                  <Form.Label>Post Content Name:</Form.Label>
                  <Form.Control
                    type="text"
                    name="postcontentname"
                    value={formData.postcontentname}
                    onChange={handleChange}
                    placeholder="Post Content Name"
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="postcontenttitle">
                  <Form.Label>Post Content Title:</Form.Label>
                  <Form.Control
                    type="text"
                    name="postcontenttitle"
                    value={formData.postcontenttitle}
                    onChange={handleChange}
                    placeholder="Post Content Title"
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="postcontent">
                <Form.Label>Post Content:</Form.Label>
                <JoditEditor
                  ref={editor}
                  value={formData.postcontent}
                  id="postcontent"
                  className="form-control"
                  name="postcontent"
                  onChange={handleContentChange}
                />
              </Form.Group>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="postcontenttype">
                  <Form.Label>Post Content Type:</Form.Label>
                  <Form.Control
                    type="text"
                    name="postcontenttype"
                    value={formData.postcontenttype}
                    onChange={handleChange}
                    placeholder="Post Content Type"
                    maxLength={20}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="postid">
                  <Form.Label>Post Id:</Form.Label>
                  <Form.Control
                    type="number"
                    name="postid"
                    value={formData.postid}
                    onChange={handleChange}
                    placeholder="Post Id"
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md={6} controlId="postlocationid">
                  <Form.Label>Post Location Id:</Form.Label>
                  <Form.Control
                    type="number"
                    name="postlocationid"
                    value={formData.postlocationid}
                    onChange={handleChange}
                    placeholder="Post Location Id"
                  />
                </Form.Group>
              </Row>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-primary">
                  Update Post Content
                </button>
                <Link to="/postlist" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <ToastContainer />

      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Post Content Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sure you want to update post content?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUpdateModal(false)}>
            Cancel
          </Button>
          <Button type="button" onClick={handleUpdate} variant="primary" style={{ marginLeft: '10px' }}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdatePostContent;
